import { CreateFormResponse } from '../types';
import { FormCreateResponseApi } from '../types/formCreateApi';

export const mapCreateFormResponse = (
  response: FormCreateResponseApi
): CreateFormResponse => ({
  formId: response.id,
  publicUrl: response.form_link,
  version: response.version,
  sourceTrackingEnabled: response.is_source_tracking_enabled
});

export default mapCreateFormResponse;
